import { FilterConfig } from 'common/models/filter.model';
import { GLOBAL_FILTERS } from './constants';
import { FILTER_ITEMS } from './constants-filter-configs';

export const THEME_ANALYTICS_FILTER: FilterConfig[] = [
  FILTER_ITEMS.dateRange,
  FILTER_ITEMS.surveyQuestionResponse,
  ...GLOBAL_FILTERS,
  FILTER_ITEMS.categoryStatus,
  FILTER_ITEMS.alignmentChange,
  FILTER_ITEMS.tags,
  FILTER_ITEMS.sentiment,
  FILTER_ITEMS.insightSourceName,
];

export const THEME_ANALYTICS_SEGMENT_FILTER: FilterConfig[] = [
  FILTER_ITEMS.accountCountry,
  FILTER_ITEMS.keyword,
  FILTER_ITEMS.diseaseState,
  FILTER_ITEMS.treatment,
  FILTER_ITEMS.topic,
];
